export default __webpack_public_path__ + "static/media/facebook-icon.839e44fb.svg";